/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentSaveDiscountViewModel } from "../types/IndividualPaymentSaveDiscountViewModel.ts";

export const individualPaymentSaveDiscountViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  discountTypeId: z.optional(z.number().int()),
  percentage: z.optional(z.number()),
  description: z.string().nullish(),
  active: z.optional(z.boolean()),
  deleteJustification: z.string().nullish(),
  associatedCompanyId: z.number().int().nullish(),
}) as unknown as ToZod<IndividualPaymentSaveDiscountViewModel>;
